// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .combined-slider {
  align-items: center;
  position: relative;
  will-change: opacity;
  opacity: 0;
  transition: 0.4s opacity ease-in 0.7s;
  visibility: hidden;
  display: none;
}
app-root .combined-slider.show {
  visibility: visible;
  opacity: 1;
  display: flex;
}
app-root .combined-slider .MuiSlider-root {
  color: var(--primary);
}
app-root .combined-slider .MuiSlider-root .MuiSlider-rail {
  background-color: #DCDCDC;
  opacity: 1;
}
app-root .combined-slider .MuiSlider-root .MuiSlider-thumb {
  background-color: white;
  border: 3px solid currentColor;
}
app-root .combined-slider .MuiSlider-root .MuiSlider-thumb:hover {
  box-shadow: 0px 0px 0px 8px rgba(62, 62, 62, 0.16);
}
app-root .combined-slider .MuiSlider-root .MuiSlider-thumb.Mui-focusVisible {
  box-shadow: 0px 0px 0px 8px rgba(62, 62, 62, 0.16);
}
app-root .combined-slider .MuiSlider-root .MuiSlider-thumb.Mui-active {
  box-shadow: 0px 0px 0px 14px rgba(175, 35, 28, 0.16);
}
app-root .combined-slider .hb-input {
  position: static;
}
app-root .combined-slider .hb-input input {
  background-color: transparent;
  border-color: transparent;
  width: 3.8rem;
  margin-left: 12px;
  padding-right: 0.25rem;
}
app-root .combined-slider .hb-input input.increase-width {
  width: 4.5rem;
}
app-root .combined-slider .hb-input input:hover {
  border-color: var(--hover-grey);
}
app-root .combined-slider .hb-input .error-message {
  position: absolute;
  right: 50%;
  transform: translateX(50%);
}
`, "",{"version":3,"sources":["webpack://./src/Views/FormSteps/Location/Base/CombinedSlider/CombinedSlider.less"],"names":[],"mappings":"AAAA;EAEI,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,UAAA;EACA,qCAAA;EAEA,kBAAA;EACA,aAAA;AAFJ;AAII;EACE,mBAAA;EACA,UAAA;EACA,aAAA;AAFN;AAbA;EAmBM,qBAAA;AAHN;AAhBA;EAsBQ,yBAAA;EACA,UAAA;AAHR;AApBA;EA2BQ,uBAAA;EACA,8BAAA;AAJR;AAMQ;EACE,kDAAA;AAJV;AAOQ;EACE,kDAAA;AALV;AAQQ;EACE,oDAAA;AANV;AAjCA;EA6CM,gBAAA;AATN;AApCA;EAgDQ,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AATR;AAWQ;EAAmB,aAAA;AAR3B;AAUQ;EACE,+BAAA;AARV;AAjDA;EA8DQ,kBAAA;EACA,UAAA;EACA,0BAAA;AAVR","sourcesContent":["app-root {\n  .combined-slider {\n    align-items: center;\n    position: relative;\n\n    will-change: opacity;\n    opacity: 0;\n    transition: 0.4s opacity ease-in 0.7s;\n\n    visibility: hidden;\n    display: none;\n\n    &.show {\n      visibility: visible;\n      opacity: 1;\n      display: flex;\n    }\n\n    .MuiSlider-root {\n      color: var(--primary);\n\n      .MuiSlider-rail {\n        background-color: #DCDCDC;\n        opacity: 1;\n      }\n\n      .MuiSlider-thumb {\n        background-color: white;\n        border: 3px solid currentColor;\n\n        &:hover {\n          box-shadow: 0px 0px 0px 8px rgb(62 62 62 / 16%);\n        }\n\n        &.Mui-focusVisible {\n          box-shadow: 0px 0px 0px 8px rgb(62 62 62 / 16%);\n        }\n\n        &.Mui-active {\n          box-shadow: 0px 0px 0px 14px rgb(175 35 28 / 16%);\n        }\n      }\n    }\n\n    .hb-input {\n      position: static;\n\n      input {\n        background-color: transparent;\n        border-color: transparent;\n        width: 3.8rem;\n        margin-left: 12px;\n        padding-right: 0.25rem;\n\n        &.increase-width { width: 4.5rem; }\n\n        &:hover {\n          border-color: var(--hover-grey);\n        }\n      }\n\n      .error-message {\n        position: absolute;\n        right: 50%;\n        transform: translateX(50%);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
